<template>
    <div>
        <br><br>
        <b-container>
            <b-jumbotron fluid header="Impressum"></b-jumbotron>
            <div v-for="(row, index) in visibleItems()" :key="index" class="textRow">
                <span v-html="row.text"></span><br>
            </div>
        </b-container>
        <br><br>
    </div>
</template>

<script>
import axios from 'axios'
export default {
  data() {
    return {
      data: {}
    }
  },
    mounted() {
        axios.get('/konfiguration/impressum.json').then((response) => {
            this.data = response.data
        }).catch((err)=>{this.test=err});
    },
  methods: {
    visibleItems: function () {
      return this.data.rows.filter(function(row) {return row.visible == true;});
    }
  }
}
</script>

<style scoped>
.jumbotron-fluid {
    padding-left: 20px!important;
    padding-right: 20px!important;
}

* >>> a {
  color: black!important;
  text-decoration: underline!important;
}

* >>> a:hover {
  color: #989898!important;
  text-decoration: underline!important;
}

.container {
    padding-left: 0px!important;
    padding-right: 0px!important;
}

.textRow {
    padding-right: 30px;
    padding-left: 30px;
}
</style>